import { IS_RECRUITER } from '../../../utils/constants'
import { BASE_URL } from '../../constants'

const token = JSON.parse(localStorage.getItem('token'))

export const getMyListOfTalents = ({
  page = 0,
  searchByText = '',
  talentValidated = false,
  category = '',
  year = '',
  stateFeedback = 0,
  skills = [],
}) => {
  const URL = `${BASE_URL}/getTalentsMyRed?searchByText=${searchByText}&page=${page}&talentValidated=${talentValidated}&category=${category}&year${year}&stateFeedback=${stateFeedback}&skills=${skills}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res || [])

    return response
  } catch (error) {
    console.log(error)
  }
}

export const getTalentDetailFromRecruiter = (data) => {
  const URL = `${BASE_URL}/getprofilemyredtalent/${data?.talentId}-${data?.param}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res?.conten || [])

    return response
  } catch (error) {
    console.log(error)
  }
}

export const getAllOffersFromRecruiter = ({
  page = 0,
  isJunior = true,
  hutritNextPublic = false,
  search = '',
}) => {
  const URL = `${BASE_URL}getalloffers?page=${page || 0}&hutritNext=${
    IS_RECRUITER ? false : isJunior
  }&hutritNextPublic=${hutritNextPublic ?? false}&search=${search}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res?.offers || [])

    return response
  } catch (error) {
    console.log(error)
  }
}

export const validateTalentInformation = async (data) => {
  const URL = `${BASE_URL}/activemytalent`

  const rawBody = JSON.stringify(data)

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })

    const res = await response.json()

    return { response, res }
  } catch (error) {
    console.log(error)
  }
}

export const sendTalentFeedback = (data) => {
  const URL = `${BASE_URL}/sendmailmytalentred`

  const rawBody = JSON.stringify(data)

  try {
    const response = fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })

    return response
  } catch (error) {
    console.log(error)
  }
}

export const updateRecruiterInformation = (data) => {
  const URL = `${BASE_URL}user/update-recruiter`

  const rawBody = JSON.stringify(data)

  try {
    const response = fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })

    return response
  } catch (error) {
    console.log(error)
  }
}

export const detailsOfferByRecruiter = ({ id }) => {
  const URL = `${BASE_URL}getDetailsOfAnOfferSent/${id}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res || [])

    return response
  } catch (error) {
    console.log(error)
  }
}

export const listOfOffersFromMyNetwork = ({ page = 0, state = 0 }) => {
  const URL = `${BASE_URL}recruiter/listOfOffersFromMyNetwork?page=${page}&state=${state}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res.offer || [])

    return response
  } catch (error) {
    console.log(error)
  }
}

export const listActiveProcesses = ({
  page = 0,
  order = '',
  searchText = '',
}) => {
  const URL = `${BASE_URL}user/getListProcessesByRecruiter?order=${order}&searchText=${searchText}&page=${page}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res?.listProcesses || {})

    return response
  } catch (error) {
    console.log(error)
  }
}

export const activeProcessesPositionTalent = ({
  offerSubmissionId = 0,
  talentId = 0,
}) => {
  const URL = `${BASE_URL}user/getPositionInTheTalent?offerSubmissionId=${offerSubmissionId}&talentId=${talentId}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res?.processDetail || [])

    return response
  } catch (error) {
    console.log(error)
  }
}

export const activeProcessesPositionTalentV2 = ({ offerSubmissionId = 0 }) => {
  const URL = `${BASE_URL}user/getPositionByTalent?offerSubmissionId=${offerSubmissionId}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res?.processDetail || [])

    return response
  } catch (error) {
    console.log(error)
  }
}

export const companiesCounts = () => {
  const URL = `${BASE_URL}recruiter/accountantsMyCompanies`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res?.accountants || [])

    return response
  } catch (error) {
    console.log(error)
  }
}

export const tmListCompanies = ({
  page = 0,
  searchByText = '',
  approved = false,
}) => {
  const URL = `${BASE_URL}recruiter/listMyCompanies?page=${page}&searchByText=${searchByText}&companiesAuthorized=${approved}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res?.companies || [])

    return response
  } catch (error) {
    console.log(error)
  }
}

export const validationMultipleAutomaticTalents = async (data) => {
  const URL = `${BASE_URL}user/action/validationMultipleAutomaticTalents`

  const rawBody = JSON.stringify(data)

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })

    const res = await response.json()

    return { response, res }
  } catch (error) {
    console.log(error)
  }
}
